import { render, staticRenderFns } from "./AddTrailerModal.vue?vue&type=template&id=4f8e0dbe&"
import script from "./AddTrailerModal.vue?vue&type=script&lang=ts&"
export * from "./AddTrailerModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports